export const GenericAccountsSearchFormKey = {
  genericAccountNameFilter: "genericAccountNameFilter",
  genericAccountName: "genericAccountName",
  purpose: "purpose",
  clientId: "clientId",
  clientName: "clientName",
  nextView: "nextView",
  country: "country",
  nextProgramClass: "nextProgramClass",
  deliveryOffice: "deliveryOffice",
  genericAccountStatus: "genericAccountStatus",
  requestedBy: "requestedBy",
} as const;

export interface GenericAccountsSearchFormProps {
  genericAccountName: string;
  genericAccountNameFilter: string;
  purpose: string;
  clientId: string;
  clientName: string;
  nextView: string;
  country: string;
  nextProgramClass: string;
  deliveryOffice: string[];
  genericAccountStatus: string;
  requestedBy: string;
}

export const GenericAccountsSearchResultFormKey = {
  genericAccountName: "genericAccountName",
  clientName: "clientName",
  purpose: "purpose",
  registrationCode: "registrationCode",
  assignedAccounts: "assignedAccounts",
  registeredAccounts: "registeredAccounts",
  programDurationDays: "programDurationDays",
  nextView: "nextView",
  nextProgramClass: "nextProgramClass",
  genericAccountStatus: "genericAccountStatus",
  country: "country",
  expirationDate: "expirationDate",
  requestedBy: "requestedBy",
  tableBody: "tableBody",
  tableRow: "tableRow",
  tableFooter: "tableFooter",
  tablePagination: "tablePagination",
  tablePaginationPageNo: "tablePaginationPageNo",
} as const;

export const GenericAccountsSearchSaveFilterFormKey = {
  filterName: "filterName",
} as const;
export interface GenericAccountsRowValue {
  id: string;
  genericAccountName?: string;
  client: string;
  purpose: string;
  registrationCode: string;
  assignedAccounts?: string;
  registeredAccounts?: string;
  programDurationDays: string;
  nextView: string;
  nextProgramClass: string;
  genericAccountStatus: string;
  country: string;
  expirationDate: string;
  requestedBy: string;
  edit?: any;
  [key: string]: any;
}

export type ViewType = "list";
